import request from '@/utils/request'

export function getList() {
  return request({
    url: '/question/lists',
    method: 'get',
  })
}
